// src/AgencyRegistrationForm.js
import React, { useState,useEffect } from "react";
import "./Agencyreg.css";
import Loader2 from "../Skleton/Loader2";


import { useNavigate } from "react-router-dom";

function AgencyReg() {
  const [agencyId, setAgencyId] = useState("");
  const [agencyName, setAgencyName] = useState("");
  const [email, setEmail] = useState("");
  const [websiteLink, setWebsiteLink] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [password, setPassword] = useState(""); // State for password
  const [confirmPassword, setConfirmPassword] = useState(""); // State for confirm password
  const [city, setcity] = useState('')
  const [number, setnumber] = useState('')
  const [suggestions, setSuggestions] = useState([]);
  const [isloading, setisloading] = useState(false)
  const nav = useNavigate()


  useEffect(() => {
    const storedEmail = localStorage.getItem('Agencyid');
    if (storedEmail) {

      nav('/agencyachivements')

    }

    }


  , [])




  
  useEffect(() => {
    fetchSuggestions();
  }, [city]);


  const fetchSuggestions = () => {
    const mapboxAccessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw'; // Replace with your Mapbox access token

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${city}.json?country=IN&types=place&access_token=${mapboxAccessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        // Filter the results to get only city names
        const cityNames = data.features
          .filter((feature) => feature.place_type.includes('place'))
          .map((feature) => feature.place_name.split(',')[0]);

        // Update the suggestions state
        setSuggestions(cityNames);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };




    
    




  async function handleSubmit (e) {


    


    e.preventDefault();

    // Check if any input field is empty
    if (
      !agencyId ||
      !agencyName ||
      !email ||
      !websiteLink ||
      !selectedOption ||
      !password ||
      !confirmPassword
    ) {
      alert("Please fill in all fields");
      return;
    }

    // Perform email validation
    if (!isValidEmail(email)) {
      alert("Invalid email address");
      return;
    }

    // Perform link validation
    if (!isValidLink(websiteLink)) {
      alert("Invalid website link");
      return;
    }

    // Check if passwords match
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;


      
    }

    setisloading(true)
    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/agencyreg', {
    method: 'POST',
    body: JSON.stringify({agencyId,agencyName,email,password,websiteLink,selectedOption,city ,number }),
    headers: { 'Content-Type': 'application/json' },
  });
  const post = await res.json();


setisloading(false)


  if(post==="done"){

    localStorage.setItem('Agencyid', agencyId);





    nav('/agencyachivements')


    



  }



  else{






  }



  };












  
  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Link validation function
  const isValidLink = (link) => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(link);
  };

  // Function to handle dropdown change
  const handleDropdownChange = (e) => {
    setSelectedOption(e.target.value);
  };

  return (<>



  {isloading?<>
  
  
  
  
  
    <Loader2/>

  
  
  </>:<>
  
  
  <br />
  <br />
    <div className="registration-form">
      <h2>Disaster Agency Registration</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="agencyId">Agency ID</label>
          <input
            className="inp"
            type="text"
            id="agencyId"
            value={agencyId}
            onChange={(e) => setAgencyId(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="agencyName">Agency Name</label>
          <input
            className="inp"
            type="text"
            id="agencyName"
            value={agencyName}
            onChange={(e) => setAgencyName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email ID</label>
          <input
            className="inp"
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Contact Number</label>
          <input
            className="inp"
            type="text"
            id="email"
            value={number}
            onChange={(e) => setnumber(e.target.value)}
            required
          />
        </div>



        <div className="form-group">
          <label htmlFor="email">City name </label>
          <input
            className="inp"
            type="text"
            id="email"
            value={city}
            onChange={(e) => setcity(e.target.value)}
            required
          />



<ul className="mt-2">
          {suggestions.map((city, index) => (
            <li  key={index} className="p-2 border-b last:border-b-0"   onClick={()=>setcity(city)}>
              {city}
            </li>
          ))}
        </ul>
        </div>







        <div className="form-group">
          <label htmlFor="websiteLink">Website Link</label>
          <input
            className="inp"
            type="text"
            id="websiteLink"
            value={websiteLink}
            onChange={(e) => setWebsiteLink(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="expertise">Expertise</label>
          <select
            id="expertise"
            value={selectedOption}
            onChange={handleDropdownChange}
            required
          >
            <option value="">Select Expertise</option>
            <option value="Search and Rescue">Search and Rescue</option>
            <option value="Emergency Medical Services">
              Emergency Medical Services
            </option>
            <option value="Firefighting">Firefighting</option>
            <option value="Logistics and Supply Chain">
              Logistics and Supply Chain
            </option>
            <option value="Emergency Management">Emergency Management</option>
            <option value="others">Others</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            className="inp"
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            className="inp"
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button className="btnloc" type="submit">Register</button>



        <p className="mt-4 text-blue-500 "    onClick={()=>nav('/agencysignin')}>
          Sign in ?
        </p>


      </form>
    </div>
  
  
  
  </>
  
  
  }


    </>
  );
}

export default AgencyReg;

                                             
                                             
                                             
                                             
                 